
import { Vue, Component, Watch } from 'vue-property-decorator'

import {
    ALLOWED_LOCATION_DRAWING_EXTENSIONS_QUERY,
    PROJECT_LOCATION_DRAWINGS_QUERY,
} from '@/views/Project/gql/queries'

import { PageInfo } from '@/schema'
import { projectClient } from '@/apolloClient'
import { SET_LOCATION_DRAWING_IS_ARCHIVED_MUTATION } from '@/views/Project/gql/mutations'

import { openDialog } from '@/_components/dialog/dialog'
import LocationDrawingDialog from '../dialogs/locationDrawing.vue'
import RichTextField from '@/components/RichTextField/richTextField.vue'

@Component({
    components: { RichTextField },
})
export default class SettingsLocationDrawings extends Vue {
    // Search location Drawings
    infiniteId = null as any
    loadingLocationDrawings = false
    locationDrawings: Array<any> = []
    pageInfo = null as Maybe<PageInfo>
    includeArchived = false

    get filteredLocationDrawings() {
        return this.includeArchived
            ? this.locationDrawings
            : this.locationDrawings.filter((item) => !item.isArchived)
    }

    async searchLocationDrawings($state: any) {
        try {
            const variables = {
                projectId: this.currentProjectId,
                after: this.pageInfo?.endCursor || null,
            }

            const { data: locationDrawingsResult } = await projectClient.query({
                query: PROJECT_LOCATION_DRAWINGS_QUERY,
                variables,
                fetchPolicy: 'network-only',
            })
            this.locationDrawings = this.locationDrawings.concat(
                locationDrawingsResult?.locationDrawings?.nodes || []
            )

            //LocationDrawingsConnection
            this.pageInfo = locationDrawingsResult.locationDrawings.pageInfo || null

            if (this.pageInfo?.hasNextPage === false) {
                $state.complete()
            } else {
                $state.loaded()
            }
        } catch (error) {
            $state.complete()
            throw error
        }
    }

    @Watch('currentProjectId', { immediate: true })
    async updateOnProjectChange() {
        await this.getAllowedLocationDrawingExtensions()
        this.pageInfo = null
        this.locationDrawings = []
        this.infiniteId = crypto['randomUUID']()
    }

    // Create Location Drawing
    async createDrawing() {
        const res = await openDialog(LocationDrawingDialog, {
            projectId: this.currentProjectId,
            requirements: { allowedExtensions: this.requirements },
        })

        if (res) {
            this.locationDrawings.push(res)
        }
    }

    // Edit Location Drawing
    async setLocationDrawingIsArchived(locationDrawing: any) {
        try {
            const index = this.locationDrawings.findIndex((item) => item.id == locationDrawing.id)
            const variables = {
                id: locationDrawing.id,
                isArchived: !locationDrawing.isArchived,
            }

            const { data } = await projectClient.mutate({
                mutation: SET_LOCATION_DRAWING_IS_ARCHIVED_MUTATION,
                variables,
            })

            const newLocationDrawing = data?.setLocationDrawingIsArchived?.locationDrawing
            if (newLocationDrawing) Vue.set(this.locationDrawings, index, newLocationDrawing)
        } catch (error) {
            throw error
        }
    }

    async updateLocationDrawing(locationDrawing: any) {
        const res = await openDialog(LocationDrawingDialog, {
            projectId: this.currentProjectId,
            requirements: { allowedExtensions: this.requirements },
            locationDrawing: locationDrawing,
        })

        if (res) {
            const index = this.locationDrawings.findIndex((item) => item.id == locationDrawing.id)
            Vue.set(this.locationDrawings, index, res)
        }
    }

    // Attachment Constraints
    requirements = [] as Array<string>

    async getAllowedLocationDrawingExtensions() {
        try {
            const locationDrawingsExtensionsResult = await projectClient.query({
                query: ALLOWED_LOCATION_DRAWING_EXTENSIONS_QUERY,
                fetchPolicy: 'network-only',
            })

            if (
                this.lodash.isArray(
                    locationDrawingsExtensionsResult.data.allowedLocationDrawingExtensions
                )
            )
                this.requirements =
                    locationDrawingsExtensionsResult.data.allowedLocationDrawingExtensions
        } catch (error) {
            throw error
        }
    }
}
